import { Environment } from './environment.model';
import { NgxLoggerLevel } from 'ngx-logger';

export const environment: Environment = {
  production: false,
  logLevel: NgxLoggerLevel.TRACE,
  firebase: {
    emulator: false,
    config: {
      apiKey: 'AIzaSyD9VY_uBP-zhUeefJp8ddVFTy5M4-1I2SI',
      authDomain: 'nbinar-development.firebaseapp.com',
      databaseURL: 'https://nbinar-development.firebaseio.com',
      projectId: 'nbinar-development',
      storageBucket: 'nbinar-development.appspot.com',
      messagingSenderId: '820892476457',
      appId: '1:820892476457:web:abc6b95224d66b4e14e838',
    },
  },
  algolia: {
    appId: 'ZQCSHEEB4M',
    apiKey: '3c45ecc3bf512c2fbf5595a67841bd43',
  },
  domain: 'https://nbinar-development.web.app',
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
